


































import {
  defineComponent,
  ref,
  ComponentInternalInstance,
  getCurrentInstance,
  watch,
  nextTick,
  onUnmounted,
  onMounted,
} from '@vue/composition-api';
import { CloseIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import MessageList from './components/MessageList.vue';
export default defineComponent({
  components: {
    CloseIcon,
    MessageList,
  },
  setup(props, context) {
    const showNoticeCenter = ref(false);
    const arrowLeftPos = ref('255px');
    const messagePanel = ref('all');
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const strAllMessageTabName = ref(i18n_t('全部通知'));
    const goToIndexPage = () => {
      showNoticeCenter.value = false;
    };
    const reportTabType = () => {
      if (messagePanel.value === 'system') {
        reporter.report('notification', {
          notification_enter: 'news_official',
        });
      } else if (messagePanel.value === 'warn') {
        reporter.report('notification', {
          notification_enter: 'news_warning',
        });
      } else {
        reporter.report('notification', {
          notification_enter: 'news_all',
        });
      }
    };
    const noticeCenterShow = ({ show, tab }: { show?: boolean; tab?: string }) => {
      const isShow = showNoticeCenter.value;
      showNoticeCenter.value = show !== undefined ? show : true;
      messagePanel.value = tab || messagePanel.value;
      if (showNoticeCenter.value && !isShow) {
        // 关闭状态下打开要上报
        reportTabType();
      }
    };
    const onUpdateTotalNum = (totalNum: any) => {
      if (totalNum > 0) {
        strAllMessageTabName.value = i18n_t('全部通知({totalNum})', {
          totalNum,
        });
      } else {
        strAllMessageTabName.value = i18n_t('全部通知');
      }
    };
    watch(showNoticeCenter, () => {
      if (showNoticeCenter.value) {
        nextTick(() => {
          const noticeButton = document.getElementById('noticeButton');
          const noticeCenter = document.getElementById('noticeCenter');
          const noticeButtonLeft = noticeButton?.offsetLeft as number;
          const noticeCenterLeft = noticeCenter?.offsetLeft as number;
          const noticeCenterWidth = noticeCenter?.offsetWidth as number;
          let arrowleft = noticeButtonLeft - noticeCenterLeft + 256;
          // 箭头超过消息中心宽度,需要保证在宽度范围之内
          if (arrowleft > noticeCenterWidth - 25) {
            arrowleft = noticeCenterWidth - 25;
          }
          arrowLeftPos.value = `${arrowleft}px`;
        });
      }
    });
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.NOTICE_CENTER_SHOW, noticeCenterShow);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.NOTICE_CENTER_SHOW, noticeCenterShow);
    });
    return {
      messagePanel,
      goToIndexPage,
      showNoticeCenter,
      arrowLeftPos,
      onUpdateTotalNum,
      strAllMessageTabName,
      reportTabType,
    };
  },
});
